export const SecondaryTypeMap = {
    LANG: 3,
    ENABLED: 4,
    RULES: 5,
    MixSwitch: 6,
};
